export const RESTRICTION_TYPE = {
  NONE: 'NONE',
  PRIVILEGED_ONLY: 'PRIVILEGED_ONLY',
  SELECTED_ONLY: 'SELECTED_ONLY',
};

export const RESTRICTION_OPTIONS = [
  {
    label: 'Everyone can post',
    value: RESTRICTION_TYPE.NONE,
  },
  {
    label: 'Only admins and managers can post',
    value: RESTRICTION_TYPE.PRIVILEGED_ONLY,
  },
  {
    label: 'Only specified members can post',
    value: RESTRICTION_TYPE.SELECTED_ONLY,
  },
];
